module.exports = __webpack_public_path__ + "img/warning.d6fae8f8.jpg";